import { Button, Backdrop, Box, Fade, Modal, Typography } from '@mui/material';

import { gradientBorder } from '../../../assets/styles/button.style';
import {
  primaryHeader,
  secondarySentence,
} from '../../../assets/styles/text.style';
import ModalProps from '../../../interfaces/ModalProps';

interface AlertWithTriggerProps extends ModalProps {
  handleClose: () => void;
  headerText: string;
  alertText: string;
}
const style = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column',
  borderRadius: '.7rem',
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 300,
  bgcolor: 'background.paper',
  boxShadow: 'rgba(0, 0, 0, 0.16) 0px 1px 4px',
  p: 3,
  textAlign: 'center',
};

const AlertWithTriggerComponent = ({
  open,
  handleClose,
  headerText,
  alertText,
}: AlertWithTriggerProps) => {

  const handleModalCLoseHandler = () => {
    handleClose();
  };
  return (
    <Modal
      aria-labelledby='transition-modal-title'
      aria-describedby='transition-modal-description'
      open={open}
      closeAfterTransition
      slots={{ backdrop: Backdrop }}
      slotProps={{
        backdrop: {
          timeout: 500,
        },
      }}
    >
      <Fade in={open}>
        <Box sx={style}>
          <Typography
            id='transition-modal-title'
            variant='h6'
            component='h2'
            sx={{ marginBottom: '.2rem', ...primaryHeader }}
          >
            {headerText}
          </Typography>
          <Typography
            id='transition-modal-description'
            sx={{
              ...secondarySentence,
              color: 'black',
              textAlign: 'center',
              mt: '20px',
            }}
          >
            {alertText}
          </Typography>

          {/* Done Button */}
          <Button
            variant='outlined'
            fullWidth
            onClick={handleModalCLoseHandler}
            sx={{
              ...gradientBorder,
              color: 'black',
              margin: '2rem 0 0 0',
            }}
          >
            Done
          </Button>
        </Box>
      </Fade>
    </Modal>
  );
};

export default AlertWithTriggerComponent;
